export default __webpack_public_path__ + "static/media/gettin-started-active.48c67b64.svg";